<template>
    <button type="button" @click="go" :disabled="disabled"><slot></slot></button>
</template>

<script>
    export default {
        props: {
            to: {
                required: true
            }
        },

        data: function () {
            return {
                disabled: false,
            }
        },

        methods: {
            go() {
                this.disabled = true
                this.$router.push(this.to)
            }
        }
    }
</script>
